module.exports = __webpack_public_path__ + "static/media/dashboard_ icon_active.2a165ef1.svg";